// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ExamplePrimitive = {
    integer: (value) => {
        return {
            integer: value,
            type: "integer",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    long: (value) => {
        return {
            long: value,
            type: "long",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    uint: (value) => {
        return {
            uint: value,
            type: "uint",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    uint64: (value) => {
        return {
            uint64: value,
            type: "uint64",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    float: (value) => {
        return {
            float: value,
            type: "float",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    double: (value) => {
        return {
            double: value,
            type: "double",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    boolean: (value) => {
        return {
            boolean: value,
            type: "boolean",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    string: (value) => {
        return {
            string: value,
            type: "string",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    date: (value) => {
        return {
            date: value,
            type: "date",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    datetime: (value) => {
        return Object.assign(Object.assign({}, value), { type: "datetime", _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            } });
    },
    datetimeRfc2822: (value) => {
        return Object.assign(Object.assign({}, value), { type: "datetimeRfc2822", _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            } });
    },
    uuid: (value) => {
        return {
            uuid: value,
            type: "uuid",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    base64: (value) => {
        return {
            base64: value,
            type: "base64",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    bigInteger: (value) => {
        return {
            bigInteger: value,
            type: "bigInteger",
            _visit: function (visitor) {
                return FernIr.ExamplePrimitive._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "integer":
                return visitor.integer(value.integer);
            case "long":
                return visitor.long(value.long);
            case "uint":
                return visitor.uint(value.uint);
            case "uint64":
                return visitor.uint64(value.uint64);
            case "float":
                return visitor.float(value.float);
            case "double":
                return visitor.double(value.double);
            case "boolean":
                return visitor.boolean(value.boolean);
            case "string":
                return visitor.string(value.string);
            case "date":
                return visitor.date(value.date);
            case "datetime":
                return visitor.datetime(value);
            case "datetimeRfc2822":
                return visitor.datetimeRfc2822(value);
            case "uuid":
                return visitor.uuid(value.uuid);
            case "base64":
                return visitor.base64(value.base64);
            case "bigInteger":
                return visitor.bigInteger(value.bigInteger);
            default:
                return visitor._other(value);
        }
    },
};
